<template>
  <div v-if="isVisible" class="screen-saver">
    <!-- 屏保内容 -->
    <swiper ref="mySwiper" :options="swiperOptions"
      @slideChange="onSlideChange"
      @reachEnd="onReachEnd"
      @slideChangeTransitionEnd="onSlideChangeTransitionEnd"
    >
      <swiper-slide v-for="(item, index) in items" :key="index">
        <div v-if="item.type === 'video/mp4'" class="video-slide">
          <video :src="item.url" @ended="onVideoEnded" controls></video>
        </div>
        <div v-else class="image-slide">
          <img :src="item.url" alt="image" />
        </div>
      </swiper-slide>
    </swiper>

    <div class="screen-mark"></div>
  </div>
</template>

<script>
import { getCompanyInfo } from "@api/index";
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'


export default {
  name: "ScreenSaver",
  data() {
    return {
      timeout : null,
      isVisible: false,
      swiperOptions: {
        autoplay: {
          delay: 10000, // 默认10秒
          disableOnInteraction: false,
        },
        allowTouchMove : false,
        loop: true,
        pagination: {
          el: '.swiper-pagination'
        },
      },
      items: [
        { type: 'image', src: 'http://haohuo.xglygj.cn/banner_1.jpg' },
        { type: 'video', src: 'http://haohuo.xglygj.cn/banner_2.mp4' },
      ],
      currentSlideIndex: 0,
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  created() {
    this.init();
    document.addEventListener('click', this.resetTimer);
    document.addEventListener('mousemove', this.resetTimer);
    document.addEventListener('keypress', this.resetTimer);
  },
  mounted() {
  },
  methods: {
    resetTimer() {
      let that = this;
      that.endScreenSaver()
      console.log('resetTimer')
      that.timeout = setTimeout(() => {
        console.log('开始屏保')
        that.showScreenSaver();
      }, 600000); // 10 分钟
    },
    init() {
      let that = this;
      that.initData()
      that.resetTimer();
    },
    initData () {
      let that = this;
      getCompanyInfo().then(res => {
        if (res.data.company_info && res.data.company_info.length > 0) {
          that.items = res.data.company_info
        }
      }).catch(err => {
        return that.$dialog.toast({ mes: err.msg || '请求异常' });
      })
    },
    onSlideChangeTransitionEnd() {
      const currentItem = this.items[this.currentSlideIndex];
      if (currentItem.type === 'video/mp4') {
        const videoElement = this.$refs.mySwiper.$el.querySelector('div.swiper-slide-active').querySelector('video');
        if (videoElement) {
          videoElement.play();
        }
      }
    },
    onSlideChange() {
      this.currentSlideIndex = this.$refs.mySwiper.$swiper.realIndex;
      const currentItem = this.items[this.currentSlideIndex];
      if (currentItem.type === 'video/mp4') {
        this.swiperOptions.autoplay.delay = 0; // 视频播放时不自动切换
        this.$refs.mySwiper.$swiper.autoplay.stop();
      } else {
        this.swiperOptions.autoplay.delay = 10000; // 图片播放5秒后切换
        this.$refs.mySwiper.$swiper.autoplay.start();
      }
    },
    onVideoEnded() {
      this.$refs.mySwiper.$swiper.slideNext();
    },
    showScreenSaver() {
      this.isVisible = true;
    },
    hideScreenSaver() {
      this.isVisible = false;
    },
    endScreenSaver() {
      this.hideScreenSaver();
      clearTimeout(this.timeout);
    },
  },
};
</script>

<style scoped lang="scss">
.screen-saver {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;

  .image-slide {width: 100%;background: #000; img {height: 100vh;
            display: block;
            transform:  translateX(-50%);
            left: 50%;
            position: relative;}}
  .video-slide {width: 100%;background: #000; video {width: 100vw; height: 100vh;}}
  .screen-mark {position: absolute;width: 100vw; height: 100vh;background-color: transparent;z-index: 9999;}
}
</style>
